//hooks
import { useState, useCallback } from "react";
import  { NotificationConsumer } from "./context/NotificationContext";
import { data } from "react-router-dom";

type AsyncFunction<T> = () => Promise<T>;

export const useApi = (apiFunc: AsyncFunction<any>, method:string) => {
  const [loading, setLoading] = useState<boolean>(false);
  const [error, setError] = useState<boolean>(false);
  const { setNoteMessage, setShowMessage, setStatusCode } = NotificationConsumer();

  const HandlerApi = async () => {
    setLoading(true);
    setError(false);
    try {
      const result = await apiFunc();
      if (method !== "GET") {
        if(result.code == 200) {
            setNoteMessage(result.message)
            setShowMessage(true)
            setStatusCode(result.code)
        }
        else {
          setNoteMessage(result.message)
          setShowMessage(true)
          setStatusCode(result.code)
        }
      }
      return result;
    } 
    catch (err: any) {
      setError(true);
      if (method !== "GET") {
        const msg = err?.response?.data?.message;
        const status = err?.response?.status || 500;
        setNoteMessage(msg);
        setStatusCode(status);
        setShowMessage(true);
      }
      return {data: null};
    } finally {
      setLoading(false);
    }
  };

  return {loading, error,  HandlerApi };
};
